module.exports = __webpack_public_path__ + "static/media/like-filled.e245ae60.svg";